
import React, { useState, useRef, useEffect } from 'react';
import { Box, Card, Typography, Tabs, Tab, Snackbar, Alert, IconButton, Badge } from '@mui/material';
import AdminPrescriptionOrders from "../PrescriptionManagementPages/Prescriptioncheckbillgenerate";
import MedicineOrdersScreen from "./MedicineOrdersScreen";
import DiagnosticOrdersScreen from "./DiagnosticOrdersScreen";
import NursingPhysioAdmin from "../NursingPhysiotheraphy/Bookedservices.js";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import PackageBookings from "../BookingPages/PackagesBooking.js"
import  bg from "../Logos/med_background2.png"
import { getUnseenCount } from '../../utils/orderNotifications';
import {apiRequest} from '../../fetchSetup.js'


const OrdersManagement = () => {
  const navigate = useNavigate();
  const { user, loading } = useUser();

  const getInitialTab = () => {
    try {
      const stored = sessionStorage.getItem("user");
      if (stored) {
        const u = JSON.parse(stored);
        return u.role === "diagnosticadmin" ? 1 : 0;
      }
    } catch { }
    return 0;
  };

  const initialTab = getInitialTab();

  const [activeTab, setActiveTab] = useState(initialTab);
  const [medicineSubTab, setMedicineSubTab] = useState(0);
  const [diagnosticSubTab, setDiagnosticSubTab] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showPrescription, setShowPrescription] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  // mountedTabs initialized with correct tab immediately — no useEffect race
  const [mountedTabs, setMountedTabs] = useState(() => new Set([initialTab]));
  const [mountedSubTabs, setMountedSubTabs] = useState(() => new Set([0]));

  const [mountedDiagnosticSubTabs, setMountedDiagnosticSubTabs] = useState(() => new Set([0]));
  const PAYMENT_API_BASE = process.env.REACT_APP_FAST_API;
  const [count, setCount] = useState(0);
  // ── Unseen-order notification counts, per category ──────────────────────────
  const [tabCounts, setTabCounts] = useState({
    medicine: getUnseenCount('medicine'),
    prescription: getUnseenCount('prescription'),
    diagnostic: getUnseenCount('diagnostic'),
    package: getUnseenCount('package'),
    nursing: getUnseenCount('nursing'),
  });
   const fetchOrders = async () => {
      try {
        const response = await apiRequest(
          `${PAYMENT_API_BASE}/pending/pending-orders/count`
        );
        const data = await response.json();
        setCount(data.count);
        console.log(data.count)
      } catch (error) {
        console.error(error);
      } 
    };
  

  useEffect(() => {
    fetchOrders()
    const refresh = () => setTabCounts({
      medicine: getUnseenCount('medicine'),
      prescription: getUnseenCount('prescription'),
      diagnostic: getUnseenCount('diagnostic'),
      package: getUnseenCount('package'),
      nursing: getUnseenCount('nursing'),
    });
    window.addEventListener('unseen-orders-changed', refresh);
    return () => window.removeEventListener('unseen-orders-changed', refresh);
  }, []);

  // Combined counts for the top-level tabs (sum of their child categories)
  const medicineTabCount = tabCounts.medicine + tabCounts.prescription;
  const diagnosticTabCount = tabCounts.diagnostic + tabCounts.package;
  const nursingTabCount = tabCounts.nursing;

  const canSeeMedicineTabs = () => user?.role === "admin" || user?.role === "medicineadmin";
  const canSeeDiagnosticTabs = () => user?.role === "admin" || user?.role === "diagnosticadmin";
  const canSeeNursingPhysiotherapy = () => user?.role === "admin" || user?.role === "diagnosticadmin";

  const handleTabChange = (e, v) => {
    setMountedTabs(prev => new Set([...prev, v]));
    setActiveTab(v);
    setSelectedOrder(null);
    setShowPrescription(false);
    setMedicineSubTab(0);
    setDiagnosticSubTab(0);
  };

  const handleSubTabChange = (e, v) => {
    setMountedSubTabs(prev => new Set([...prev, v]));
    setMedicineSubTab(v);
    setSelectedOrder(null);
    setShowPrescription(false);
  };
    const handleDiagnosticSubTabChange = (e, v) => {
    setMountedDiagnosticSubTabs(prev => new Set([...prev, v]));
    setDiagnosticSubTab(v);
    setSelectedOrder(null);
    setShowPrescription(false);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f5f7fa',
      pb: 4,
      ml: { xs: 0, md: '280px' },
      width: { xs: '100%', md: 'calc(100% - 280px)' },
      boxSizing: 'border-box',
      position: 'relative'
    }}>

      {/* ── Header ── */}
      <Box sx={{
        backgroundImage: `
          linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
          url(${bg})
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat" ,
        py: { xs: 2, sm: 3, md: 4 },
        px: { xs: 2, sm: 3, md: 4 },
        boxShadow: 1,
        textAlign: 'center',
        zIndex: 1100,
        position: 'sticky',
        top: 0,
      }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', color: '#006D77' }}
        >
          <ArrowBack sx={{ fontSize: 32 }} />
        </IconButton>
         <Box
    sx={{
      position: 'absolute',
      top: 16,
      right: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      backgroundColor: 'white',
      color: '#006D77',
      px: 2,
      py: 1,
      borderRadius: 2,
      fontWeight: 'bold',
      boxShadow: 2,
      cursor: 'pointer',
    }}
    onClick={() =>{navigate("/pending-orders")}}
  >
<Badge
  color="error"
  variant="dot"
  invisible={count === 0}
  sx={{
    '& .MuiBadge-dot': {
      right: -4,
      top: 2,
    },
  }}
>
  <Typography
    sx={{
      fontWeight: 'bold',
      fontSize: { xs: '13px', sm: '15px' },
    }}
  >
    Pending Orders
  </Typography>
</Badge>
  </Box>
        <Typography variant="h4" fontWeight="bold" color="white">
          Orders Management
        </Typography>
        <Typography color="white">
          Select the Order type you need
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 1400, mx: 'auto', mt: 3 }}>

        {/* ── Main tabs — admin only ── */}
        {user?.role === "admin" && (
          <Card>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              TabIndicatorProps={{ sx: { backgroundColor: '#006D77' } }}
              sx={{
                '& .MuiTab-root': { color: '#006D77' },
                '& .Mui-selected': { color: '#006D77 !important', fontWeight: 'bold' },
              }}
            >
              <Tab
                sx={{ textTransform: "none", fontSize: "20px" }}
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={medicineTabCount === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Medicines Delivery
                  </Badge>
                }
              />
              <Tab
                sx={{ textTransform: "none", fontSize: "20px" }}
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={diagnosticTabCount === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Diagnostics Sample
                  </Badge>
                }
              />
              <Tab
                sx={{ textTransform: "none", fontSize: "20px" }}
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={nursingTabCount === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Nursing & Physiotherapy
                  </Badge>
                }
              />
            </Tabs>
          </Card>
        )}

        {/* ── Medicine subtabs ── */}
        {canSeeMedicineTabs() && activeTab === 0 && (
          <Card sx={{ mt: 2 }}>
            <Tabs
              value={medicineSubTab}
              onChange={handleSubTabChange}
              TabIndicatorProps={{ sx: { backgroundColor: '#006D77' } }}
              sx={{
                '& .MuiTab-root': { color: '#006D77' },
                '& .Mui-selected': { color: '#006D77 !important', fontWeight: 'bold' },
              }}
            >
              <Tab
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={tabCounts.medicine === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Medicine Orders
                  </Badge>
                }
              />
              <Tab
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={tabCounts.prescription === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Prescription Orders
                  </Badge>
                }
              />
            </Tabs>
          </Card>
        )}
         {/* ── Diagnostic subtabs ── */}
        {canSeeDiagnosticTabs() && activeTab === 1 && (
          <Card sx={{ mt: 2 }}>
            <Tabs
              value={diagnosticSubTab}
              onChange={handleDiagnosticSubTabChange}
              TabIndicatorProps={{ sx: { backgroundColor: '#006D77' } }}
              sx={{
                '& .MuiTab-root': { color: '#006D77' },
                '& .Mui-selected': { color: '#006D77 !important', fontWeight: 'bold' },
              }}
            >
              <Tab
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={tabCounts.diagnostic === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Diagnostic Orders
                  </Badge>
                }
              />
              <Tab
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={tabCounts.package === 0}
                    sx={{ '& .MuiBadge-dot': { right: -8, top: 2 } }}
                  >
                    Package Booking Orders
                  </Badge>
                }
              />
            </Tabs>
          </Card>
        )}

        <Box mt={2}>


          {canSeeMedicineTabs() && mountedTabs.has(0) && (
            <>
              {mountedSubTabs.has(0) && (
                <Box sx={{ display: activeTab === 0 && medicineSubTab === 0 ? 'block' : 'none' }}>
                  <MedicineOrdersScreen />
                </Box>
              )}
              {mountedSubTabs.has(1) && (
                <Box sx={{ display: activeTab === 0 && medicineSubTab === 1 ? 'block' : 'none' }}>
                  <AdminPrescriptionOrders />
                </Box>
              )}
            </>
          )}


         
            {canSeeDiagnosticTabs() && mountedTabs.has(1) && (
            <>
              {mountedDiagnosticSubTabs.has(0) && (
                <Box sx={{ display: activeTab === 1 && diagnosticSubTab === 0 ? 'block' : 'none' }}>
                   <DiagnosticOrdersScreen />
                </Box>
              )}
              {mountedDiagnosticSubTabs.has(1) && (
                <Box sx={{ display: activeTab === 1 && diagnosticSubTab === 1 ? 'block' : 'none' }}>
                   <PackageBookings/>
                </Box>
              )}
            </>
          )}

          {/* ── Nursing & Physiotherapy ── */}
          {canSeeNursingPhysiotherapy() && mountedTabs.has(2) && (
            <Box sx={{ display: activeTab === 2 ? 'block' : 'none' }}>
              <NursingPhysioAdmin />
            </Box>
          )}

        </Box>
      </Box>

      {/* ── Snackbar ── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OrdersManagement;